import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect, useState } from 'react'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import * as endpoints from '../../../constants/api-constants'
import authService from '../../../services/auth-service'
import MagazineService from '../../../services/magazine'
import NotificationService from '../../../services/notification-service'
import A2hsModal from '../../modals/a2hs-modal/a2hs-modal'
import OnBoardingIOS from '../../modals/onboarding-ios/onboarding-ios'
import RestorePasswordModal from '../../modals/restore-password-modal/restore-password-modal'
import Footer from '../../molecules/footer/footer'
import Header from '../../molecules/header/header'
import Chat from '../../atoms/chat/chat'
import ModalChat from '../../modals/modal-chat/modal-chat'
import CookieConsent from '../../molecules/cookie-consent/cookie-consent'
import Logo from '../../../assets/images/logo/512-512.png'
import './layout.scss'

const Layout = props => {
  const [isLog, setIsLog] = useState(false)
  const [infoUser, setInfoUser] = useState(null)
  const [popupLogin, setPopupLogin] = useState(false)
  const [commondModal, setCommondModal] = useState(null)
  const [notificationState, setnotificationState] = useState(null)
  const [logStatus, setlogStatus] = useState('waiting')

  const logout = () => {
    setIsLog(false)
    setInfoUser(null)
    localStorage.removeItem('TOKEN_INFO')
    localStorage.removeItem('USER_INFO')
    window.location.reload()
  }

  const getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return 'sara' //Sara
    } else if (age >= 18 && age <= 24) {
      return 'carolina' //carolina
    } else {
      return 'juliana' //juliana
    }
  }

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem('USER_INFO')).birthdate
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  const eventDataLayerAge = age => {
    try {
      var birthDate = new Date(
        JSON.parse(localStorage.getItem('USER_INFO')).birthdate
      )
      window.dataLayer.push({
        anoNacimiento: birthDate,
        edad: age,
        event: 'edadUsuaria',
      })
    } catch (error) {
      console.log('dataLayer error: ', error)
    }
  }

  /**
   * Websocket config
   */
  const webSocketInit = () => {
    try {
      var socket = new SockJS(endpoints.webSocketEndPoint, null, {
        transports: 'xhr-polling',
      })

      let stompClient = Stomp.over(socket)
      stompClient.debug = null
      stompClient.connect({}, function (frame) {
        // console.log("Connected: " + frame);
        stompClient.subscribe('/topic/notifications', notification => {
          // If is not showing notification, show notification
          if (notificationState === null) {
            //Validate if is a segmented notification
            if (JSON.parse(notification.body).country) {
              if (
                JSON.parse(notification.body).country ===
                parseInt(process.env.COUNTRY_CODE)
              ) {
                //Validate user notification settings
                if (localStorage.getItem('TOKEN_INFO')) {
                  let tokenId = JSON.parse(
                    localStorage.getItem('TOKEN_INFO')
                  ).idToken

                  let config = {
                    headers: {
                      Authorization: tokenId,
                    },
                  }
                  NotificationService.notificationsSettings(config)
                    .then(res => {
                      if (res.status === 200) {
                        if (
                          res.data.filter(
                            elem =>
                              elem.code ===
                              JSON.parse(notification.body).notificationTypeCode
                          )[0].active
                        ) {
                          //Validate user age segment
                          if (JSON.parse(notification.body).segment) {
                            if (
                              getAgeSegment(calculateAge()) ===
                              JSON.parse(notification.body).segment
                            ) {
                              setnotificationState(
                                JSON.parse(notification.body)
                              )
                            }
                          } else {
                            setnotificationState(JSON.parse(notification.body))
                          }
                        }
                      } else {
                        console.log(res)
                      }
                    })
                    .catch(e => console.log(e))
                } else {
                  setnotificationState(JSON.parse(notification.body))
                }
              }
            } else {
              //Validate user notification settings
              if (localStorage.getItem('TOKEN_INFO')) {
                let tokenId = JSON.parse(
                  localStorage.getItem('TOKEN_INFO')
                ).idToken

                let config = {
                  headers: {
                    Authorization: tokenId,
                  },
                }

                NotificationService.notificationsSettings(config)
                  .then(res => {
                    if (res.status === 200) {
                      if (
                        res.data.filter(
                          elem =>
                            elem.code ===
                            JSON.parse(notification.body).notificationTypeCode
                        )[0].active
                      ) {
                        if (JSON.parse(notification.body).segment) {
                          //Validate user age segment
                          if (
                            getAgeSegment(calculateAge()) ===
                            JSON.parse(notification.body).segment
                          ) {
                            setnotificationState(JSON.parse(notification.body))
                          }
                        } else {
                          setnotificationState(JSON.parse(notification.body))
                        }
                      }
                    } else {
                      console.log(res)
                    }
                  })
                  .then(e => console.log(e))
              } else {
                setnotificationState(JSON.parse(notification.body))
              }
            }
          }
        })
      })
    } catch (e) {
      //console.log(e);
    }
  }

  /**
   * a2hs = Add To Home Screen Function
   */
  const a2hs = () => {
    window.addEventListener('beforeinstallprompt', e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault()
      // Stash the event so it can be triggered later.
      // setdeferredPrompt(e);
      // // Update UI to notify the user they can add to home screen
      // addBtn.style.display = 'block';
      if (
        localStorage.getItem('DENIED_A2HS') === null ||
        localStorage.getItem('DENIED_A2HS') === 'false'
      ) {
        setTimeout(() => {
          setCommondModal(
            <A2hsModal
              deferredPrompt={e}
              setCommondModal={setCommondModal}
              // setdeferredPrompt={setdeferredPrompt}
            />
          )
        }, 10000)
      }
    })
  }

  const onBoardingIOS = () => {
    if (
      localStorage.getItem('DENIED_ONBOARDING') === null ||
      localStorage.getItem('DENIED_ONBOARDING') === 'false'
    ) {
      setTimeout(() => {
        var body = document.getElementsByTagName('body')[0]
        var html = document.getElementsByTagName('html')[0]
        body.classList.add('overflow-body-hidden')
        html.classList.add('overflow-body-hidden')

        setCommondModal(<OnBoardingIOS setCommondModal={setCommondModal} />)
      }, 15000)
    }
  }
  /*
  const handleLoadArticlesSaved = () => {
    if (localStorage.getItem("TOKEN_INFO") !== null) {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      const listArticles = resultQuery.allContentfulNolArticulos.nodes.filter(
        e => e.node_locale === process.env.LOCALE
      )
      MagazineService.getSavedArticles(config)
        .then(res => {
          if (res.status === 200) {
            let newListArticlesSaved = []
            res.data.map(art => {
              let tempArt = listArticles.filter(a => a.contentful_id === art)[0]
              let tempPayload = {
                id: tempArt.contentful_id,
                titulo: tempArt.metaTitulo,
                descripcion: tempArt.metaDescripcion.metaDescripcion,
                imagen: tempArt.metaImagen,
                categorias: tempArt.categorias,
                slug:
                  tempArt.seccionDelArticulo === "Nuestro Mundo"
                    ? "/magazin/nuestro-mundo/" + tempArt.slug
                    : "/entre-nosotras/" + tempArt.slug,
                imagenCreadorArticulo: tempArt.imagenCreadorArticulo,
                tipoDeArticulo: tempArt.tipoDeArticulo,
                updatedAt: tempArt.fechaDePublicacion,
                nombreCreadorArticulo: tempArt.nombreCreadorArticulo,
                creadorArtculo: tempArt.creadorArtculo,
              }
              newListArticlesSaved.push(tempPayload)
              return null
            })
            localStorage.setItem(
              "SAVED_ARTICLES",
              JSON.stringify(newListArticlesSaved)
            )
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }
*/

  useEffect(() => {
    // a2hs()
    webSocketInit()

    /*
    if (navigator.onLine) {
      handleLoadArticlesSaved()
    }
*/

    if (!navigator.onLine && localStorage.getItem('TOKEN_INFO') !== null) {
      setIsLog(true)
      setlogStatus('loaded')
    }

    const isIOS = !!navigator.platform && /iPhone/.test(navigator.platform)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

    // if (isIOS && isSafari) onBoardingIOS()

    if (typeof window !== 'undefined') {
      const requestUserInfo = () => {
        var tokenId = JSON.parse(localStorage.getItem('TOKEN_INFO')).idToken

        var config = {
          headers: {
            Authorization: tokenId,
          },
        }

        authService
          .sessionInfo(config)
          .then(res => {
            if (res.status === 200) {
              setInfoUser(res.data)
              setIsLog(true)
              setlogStatus('logged')

              if (localStorage.getItem('SHOWED_POPUP') === null) {
                setPopupLogin(true)
                localStorage.setItem('SHOWED_POPUP', true)
              }

              localStorage.setItem('USER_INFO', JSON.stringify(res.data))
              //Validate if need backend response forcePasswordChange
              if (res.data.forcePasswordChange) {
                setCommondModal(
                  <RestorePasswordModal setCommondModal={setCommondModal} />
                )
              }
            } else {
              console.log(res)
            }
          })
          .catch(e => console.log(e))
      }

      //Validate if token is in localStorage to give user session info
      const store = {
        token: localStorage.getItem('TOKEN_INFO'),
      }
      if (localStorage.getItem('TOKEN_INFO') !== null) {
        requestUserInfo()
      } else {
        setlogStatus('no-logged')
      }

      const onStorageChange = event => {
        if (store.token === localStorage.getItem('TOKEN_INFO')) return
        store.token = localStorage.getItem('TOKEN_INFO')
        if (localStorage.getItem('TOKEN_INFO') !== null) {
          requestUserInfo()
        } else {
          setInfoUser(null)
          setIsLog(false)
          setlogStatus('no-logged')
        }
      }
      window.addEventListener('storage', onStorageChange)
      return () => {
        window.removeEventListener('storage', onStorageChange)
      }
    }
  }, [])

  useEffect(() => {
    if (isLog) {
      eventDataLayerAge(calculateAge())
    }
  }, [isLog])

  useEffect(() => {
    if (props.defaultUserInfo) {
      setInfoUser(props.defaultUserInfo)
      setIsLog(true)
    }
  }, [props.defaultUserInfo])

  const haveChat = ['es-CO']

  return (
    <>
      <Header
        popupLogin={popupLogin}
        mobile={props.mobile}
        modalActive={props.modalActive}
        commondModal={commondModal}
        setCommondModal={setCommondModal}
        isLog={isLog}
        logStatus={logStatus}
        infoUser={infoUser}
        setInfoUser={setInfoUser}
        logout={logout}
        notificationState={notificationState}
        setnotificationState={setnotificationState}
        redirectRegister={props.redirectRegister}
      />

      <main>{props.children}</main>
      <Chat />

      {haveChat.includes(process.env.LOCALE) && <ModalChat />}

      {process.env.ENVIRONMENT !== 'PDN' && (
        <span className="f-country-watermark">
          {process.env.COUNTRY_NAME + ' - ' + process.env.ENVIRONMENT}
        </span>
      )}
      {/* <CookieConsent logoUrl={Logo} /> */}
      <Footer setCommondModal={setCommondModal} mobile={props.mobile} />
    </>
  )
}

export default Layout
